// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-rust-contract-dialog[data-v-99fc2d9a] .el-dialog{width:var(--common-dialog-large-width)}.add-rust-contract-dialog .alert-info[data-v-99fc2d9a]{margin-bottom:var(--base-size-20);width:90%;margin-left:5%}.add-rust-contract-dialog .el-form[data-v-99fc2d9a]{margin-right:var(--base-size-48)}", ""]);
// Exports
module.exports = exports;
